export default __webpack_public_path__ + "static/media/mazda.62d2bf84.svg";